import { render, staticRenderFns } from "./CustomerLoyaltyView.vue?vue&type=template&id=2a69216c&scoped=true"
import script from "./CustomerLoyaltyView.vue?vue&type=script&lang=js"
export * from "./CustomerLoyaltyView.vue?vue&type=script&lang=js"
import style0 from "./CustomerLoyaltyView.vue?vue&type=style&index=0&id=2a69216c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a69216c",
  null
  
)

export default component.exports